import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import ErrorModalIcon from '../../../../../incase-domain/components/modals/errorModal/ErrorModalIcon';
import ErrorModalContent from '../../../../../incase-domain/components/modals/errorModal/ErrorModalContent';
import ErrorModalCloseButton from '../../../../../incase-domain/components/modals/errorModal/ErrorModalCloseButton';
import ErrorModalWrapper from '../../../../../incase-domain/components/modals/errorModal/ErrorModalWrapper';
import {roomInfoModalSelector} from '../../../../../store/selectors/roomProtection.selector';
import {setRoomInfoModalAction} from '../../../../../store/actions/roomProtection.actions';

function RoomInfoModal(): JSX.Element {
    const navigate = useNavigate();
    const infoModal = useSelector(roomInfoModalSelector);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const title = infoModal.title ? t(infoModal.title) : '';

    let description = '';
    if (infoModal.description) {
        if (infoModal.descriptionValues) {
            description = String(t(infoModal.description, infoModal.descriptionValues));
        } else {
            description = t(infoModal.description);
        }
    }

    return (
        <ErrorModalWrapper isOpen={infoModal.open}>
            <ErrorModalIcon />
            <ErrorModalContent title={title} description={description} />
            <ErrorModalCloseButton
                onClose={() => {
                    dispatch(setRoomInfoModalAction(false, '', ''));
                    navigate('/');
                }}
            />
        </ErrorModalWrapper>
    );
}

export default RoomInfoModal;
